<div *ngIf="notificacionPagoAct" class="fondo-notificacion linkNotificacion" [routerLink]="'/market'">
    <span *ngIf="notActTarjeta" class="text-center">Lo sentimos, la plataforma se encuentra inhabilitada por falta de pago. Regulariza tu pago o puedes contactarnos al correo:
        <a href="mailto:ventas@noe.pe" target="_blank" style="color: #ffffff; text-decoration: underline;">ventas@noe.pe</a></span>
    <i class="las la-times" (click)="notificacionPagoAct=false"></i>
</div>

<div *ngIf="notificacionPagoAct && notActTarjeta" class="fondo-bloqueo"></div>

<div *ngIf="notificacionPagoAct" class="fondo-notificacion linkNotificacion" [routerLink]="'/market'">
    <span *ngIf="notDocumentos" class="text-center">Agotaste la totalidad de tu plan, sigue disfutando de nuestros servicios adquiriendo uno de <span class="notDocumentosPlan">nuestros planes</span></span>
    <i class="las la-times" (click)="notificacionPagoAct=false"></i>
</div>

<div *ngIf="notificacionMantAct" class="fondo-notificacion">
    <span *ngIf="notMantenimiento" class="text-center">El día 14/04 desde las 12 hrs estaremos haciendo mantenimiento en nuestras plataformas</span>
    <i class="las la-times linkNotificacion" (click)="notificacionMantAct=false"></i>
</div>

<div class="top-bar">
    <div class="company-dropdown">
        <ng-container *ngIf="!esGratuita">
            <!--<div class="profile">
                <span class="site-logo1__logo-container">
                    <img
                        [src]="logoSidebar" style="width: 100px"
                        alt="NOE - Notificaciones Electrónicas"
                    >
                </span>-->
                <!--<button (click)="toggle($event)">
                    <i class="las la-chevron-left"></i>
                </button>-->

                <div *ngIf="sharedData!=null" class="text-bienvenido-title">{{ sharedData }}</div>

                <div *ngIf="sharedData==null" class="text-bienvenido">Bienvenido a Noe</div>

                <div class="tooltipName">
                    <div *ngIf="sharedData==null" class="text-bienvenido-sub"><span>Hola {{nombres}}, bienvenido(a)!</span></div>
                    <div class="tooltiptext">
                        <h5>Hola {{nombres}}, bienvenido(a)!</h5>
                    </div>
                </div>
                <div class="tooltipName">
                    <div class="text-bienvenido-sub"><span>Último inicio de sesión: {{dateLastSession.slice(0, -3)}}</span></div>
                </div>

                <!--<div class="selected" (click)="$event.stopPropagation(); closeDrop(); drop=!drop">
                    <b>Empresa:</b> {{empresaActiva.razon_social}}
                    <span class="arrow"></span>
                </div>-->

            <!--</div>-->

            <div class="dropdown" [class.open]="drop">
                <ul>
                    <li [class.disabled]="e.id == empresaActiva.id" *ngFor="let e of empresas" (click)="$event.stopPropagation(); seleccionarEmpresaActiva(e)">{{e.razon_social}}</li>
                </ul>
            </div>
        </ng-container>

        <a class="boton_personalizado" *ngIf="esGratuita" (click)="solicitarPremium()">Solicitar versión premium</a>

    </div>

    <div class="actions-free">
        <div class="profile-free">
            <!--<div id="google_translate_element"></div>-->

            <div *ngIf="this.authService.obtenerSubdominio() == 'portal-qa'" class="title">
                <h4 (click)="$event.stopPropagation(); closeProfileTraductor(); profileTraductor=!profileTraductor">Seleccionar Idioma <span class="arrow"></span></h4>
                <div class="dropdown" [class.open]="profileTraductor">
                    <ul>
                        <li>
                            <a href="#googtrans(es|es)" class="lang-select">Español<span><img class="img-bandera" src="../../assets/img/banderas/peru.png"></span></a>
                        </li>
                        <li>
                            <hr>
                            <a href="#googtrans(es|en)" class="lang-select">Inglés<span><img class="img-bandera" src="../../assets/img/banderas/estados-unidos.png"></span></a>
                        </li>
                        <li>
                            <hr>
                            <a href="#googtrans(es|fr)" class="lang-select">Francés<span><img class="img-bandera" src="../../assets/img/banderas/francia.png"></span></a>
                        </li>
                        <li>
                            <hr>
                            <a href="#googtrans(es|it)" class="lang-select">Italiano<span><img class="img-bandera" src="../../assets/img/banderas/italia.png"></span></a>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="title title-default">
                <div class="double-row-btn">
                    <div copilot [copilot-template]="step3" [copilot-step]="8">
                        <button class="plan-btn" *ngIf="!esPlanPersonalizado" type="submit" (click)="openModalCambiadeplan()">Cambia de plan</button>
                    </div>

                    <div copilot [copilot-template]="step2" [copilot-step]="7">
                        <button class="doc-btn" *ngIf="activarCargaDocumento" type="submit" (click)="sharedDocs();sharedDocsService();">Carga tu documento</button>
                        <button class="doc-btn-disabled" type="submit" *ngIf="!activarCargaDocumento">Carga tu documento</button>
                    </div>
                </div>
                <ng-template #step3>
                    <div class="copilot-custom-free-2 step3-free">
                        <div class="content-title">
                            <h3>Aquí podrás cambiar tu plan cuando desees.</h3>
                        </div>
                        <div class="footer-btn">
                            <div class="num-step">3/7</div>
                            <div>
                                <button class="btn-omitir" (click)="omitir();" type="button">Omitir</button>
                                <button class="btn-siguiente" (click)="siguiente(9);" type="button">Siguiente</button>
                            </div>
                        </div>
                    </div>
                </ng-template>

                <ng-template #step2>
                    <div class="copilot-custom-free-2 step2-free">
                        <div class="content-title">
                            <h3>Aquí podrás cargar tus documentos.</h3>
                        </div>
                        <div class="footer-btn">
                            <div class="num-step">2/7</div>
                            <div>
                                <button class="btn-omitir" (click)="omitir();" type="button">Omitir</button>
                                <button class="btn-siguiente" (click)="siguiente(8);" type="button">Siguiente</button>
                            </div>
                        </div>
                    </div>
                </ng-template>

            </div>

            <div class="title">

                <!--<h4 (click)="$event.stopPropagation(); closeProfileDrop(); profileDrop=!profileDrop">{{name}} <span class="arrow"></span></h4>-->
                <div class="document-arrow-free" (click)="$event.stopPropagation(); closeProfileDrop(); profileDrop=!profileDrop">
                    <div *ngIf="loadingAvatar" class="avatar-container-topbar">
                        <app-loader></app-loader>
                    </div>

                    <div *ngIf="!loadingAvatar" class="avatar-container-topbar">
                        <img class="avatar" [src]="rutaAvatar" alt="Sin imagen">
                    </div>

                    <i class="las la-angle-down circle-arrow"></i>
                </div>
                <!-- <p>{{profiles}}</p> -->

                <div class="dropdown" [class.open]="profileDrop">
                    <ul>
                        <!--<li class="profile-list">
                            <span *ngFor="let p of profiles">{{p}}</span>
                        </li>-->
                        <li>
                            <!--<hr>-->
                            <a routerLink="/configuraciones/mi-perfil" (click)="$event.stopPropagation(); profileDrop=false; sharedPerfil();">Mi Perfil</a>
                        </li>
                        <!--<li>
                            <hr>
                            <a (click)="initChangePass()">Cambiar Contraseña</a>
                        </li>
                        <li>
                            <hr>
                            <a (click)="onUpdateUser()">Modificar Mi Cuenta</a>
                        </li>-->
                        <!--<li>
                            <hr>
                            <a>Manuales y Tutoriales</a>
                        </li>-->
                        <li>
                            <hr>
                            <a (click)="$event.stopPropagation(); profileDrop=false; abrirModalLecturaTerminos();">Términos y Condiciones</a>
                        </li>
                        <li>
                            <hr>
                            <a (click)="$event.stopPropagation(); profileDrop=false; abrirModalConfirmarSalir();">Salir</a>
                        </li>
                    </ul>

                </div>
            </div>
            <!--<button class="logout" (click)="abrirModalConfirmarSalir()"><i class="las la-power-off"></i> <span>Salir</span></button>

            <button class="toggler" (click)="toggle($event)">
                <i class="las la-bars"></i>
            </button>-->
        </div>
    </div>
</div>

<div class="title title-resp">
    <div class="double-row-btn">
        <div copilot [copilot-template]="step2" [copilot-step]="7">
            <button class="doc-btn" *ngIf="activarCargaDocumento"  type="submit" (click)="sharedDocs();sharedDocsService();">Carga tu documento</button>
            <button class="doc-btn-disabled" *ngIf="!activarCargaDocumento">Carga tu documento</button>
        </div>

        <div copilot [copilot-template]="step3" [copilot-step]="8">
            <button class="plan-btn" *ngIf="!esPlanPersonalizado" type="submit" (click)="openModalCambiadeplan()">Cambia de plan</button>
        </div>
    </div>
    <ng-template #step3>
        <div class="copilot-custom-free-2">
            <div class="content-title">
                <h3>Aquí podrás cambiar tu plan cuando desees.</h3>
            </div>
            <div class="footer-btn">
                <div class="num-step">3/7</div>
                <div>
                    <button class="btn-omitir" (click)="omitir();" type="button">Omitir</button>
                    <button class="btn-siguiente" (click)="siguiente(9);" type="button">Siguiente</button>
                </div>
            </div>
        </div>
    </ng-template>

    <ng-template #step2>
        <div class="copilot-custom-free-2">
            <div class="content-title">
                <h3>Aquí podrás cargar tus documentos.</h3>
            </div>
            <div class="footer-btn">
                <div class="num-step">2/7</div>
                <div>
                    <button class="btn-omitir" (click)="omitir();" type="button">Omitir</button>
                    <button class="btn-siguiente" (click)="siguiente(8);" type="button">Siguiente</button>
                </div>
            </div>
        </div>
    </ng-template>
</div>

<!--<div class="btn-flotante" (click)="selectBoton('mainBoton','');" [ngClass]="{active: isActiveBoton('mainBoton')}">
    <img src='../../assets/img/noe-free/icon-pregunta.png' style="height: 26px; display: block; margin: 0 auto;">
    <div class="btn-desplegable-flotante">
        <div class="btn-flotante-contenido" [ngClass]="{active: isActiveBoton('subBoton')}" (click)="selectBoton('subBoton','');">
            <div class="btn-tutorial">Tutorial de firma pin</div>
            <div class="btn-tutorial">Tutorial de firma holografica</div>
            <div class="btn-tutorial">Tutorial de firma con certificado</div>
        </div>
    </div>
</div>-->

<app-modal #modalCargarDocumentos class="modalCargarDocumentos" [hide-footer]="true">

    <div class="modal-title only mb-2 d-flex">
        <strong class="title-modal"><h2>Cargar tu documento</h2></strong>
        <div class="close" (click)="closeModalCargarDocumentos();">
          <i class="las la-times"></i>
        </div>
    </div>

    <div class="drop" *ngIf="!preview">
        <app-dropzone-documentos #drop [multi]="true" (onconvert)="setPreview($event)" (ondrop)="handleUpload($event)"></app-dropzone-documentos>
    </div>

    <div class="content-img" *ngIf="preview">
        <div class="dropzone preview d-flex" *ngFor="let file of uploadList; index as i">
            <div class="d-flex">
                <img src='../../assets/img/noe-free/icon-nombre-documento.png' style="width: 40px; height: 50px; display: block; margin: 0 auto; margin-right: 30px;">
                <span class="text-pdf">{{file.name}}</span>
            </div>
            <div class="remove" (click)="removeFile(file);"><img src='../../assets/img/noe-free/icon-eliminar.png' style="width: 45px; height: 45px; display: block; margin: 0 auto;"></div>
        </div>

        <div class="botones-date d-flex">
            <button class="btn-anadir"><img src='../../assets/img/noe-free/icon-anadir.png' style="width: 20px; height: 20px; margin-top: 2px; margin-bottom: -3px; margin-right: 10px;"> Añadir documentos</button>
            <button *ngIf="!statusLoading" class="btn-continuar-pdf" (click)="crearProceso()">Continuar</button>
            <button *ngIf="statusLoading" class="btn btn-continuar-pdf disabled loading">Procesando</button>
        </div>

    </div>

</app-modal>

<app-modal #modalCambiadeplan class="modalCambiadeplan" [hide-footer]="true">
    <!--<app-table #table [head]="headPremium" [body]="bodyPremium" [showPaginator]="false" [showIconSort]="false"></app-table>-->
    <div class="modal-title mb-2 d-flex">
        <img class="logo" src='../../assets/img/noe-free/noe-white.png' style="width: 160px; display: block;">
        <div *ngIf="!verModalGracias" class="close" (click)="sharedPlan(); closeModalCambiadeplan();">
          <i class="las la-times"></i>
        </div>
    </div>

    <div class="content-tablas">
        <button *ngIf="!verProcesoPago && !verDetallesPago && !verModalGracias" class="btn-tab" [class.disabled]="verMensual" (click)="verAnual=true;verMensual=false;tipoPlanCategoria='anual'">Anual</button>
        <button *ngIf="!verProcesoPago && !verDetallesPago && !verModalGracias" class="btn-tab" [class.disabled]="verAnual" (click)="verMensual=true;verAnual=false;tipoPlanCategoria='mensual'" >Mensual</button>

        <!-- Armando tablas de plan-->
        <div *ngIf="!verProcesoPago && !verDetallesPago && !verModalGracias" class="content-tablas">
            <div class="content-tablas-1">
                <ng-container *ngFor="let plan of lstPlans; index as i;">
                    <div *ngIf="plan.id != 2" class="tabla2">
                        <h3 class="text-title-2">{{plan.name}}</h3>
                        <ng-container *ngFor="let tipo of plan.attributes.tipo_plan; index as i;">
                            <ng-container *ngIf="tipo.tipo == 'anual'  &&  verAnual">
                                <span *ngIf="plan.id != 1 else planFree" class="text-precio-2">s/ {{tipo.costo}}.00 / al año</span>
                                <ng-template #planFree>
                                    <span class="text-precio-2">Cero Costo</span>
                                </ng-template>

                                <div class="hr-form-2"></div>

                                <div class="content-lista">
                                    <div class="d-flex pd-lista">
                                        <img class="logo" src='../../assets/img/noe-free/icon-check-2.png' style="width: 18px; height: 18px; display: block; margin-right: 10px;">
                                        <span *ngIf="plan.id != 1" class="text-lista-2"><strong class="text-strong">{{tipo.options.documentos}} Documentos</strong> mensuales disponibles</span>
                                        <span *ngIf="plan.id == 1" class="text-lista-2"><strong class="text-strong">{{tipo.options.documentos}} Documentos</strong> disponibles</span>
                                    </div>
                                    <div class="d-flex pd-lista">
                                        <img class="logo" src='../../assets/img/noe-free/icon-check-2.png' style="width: 18px; height: 18px; display: block; margin-right: 10px;">
                                        <span class="text-lista-2">Carga documentos de hasta <strong class="text-strong">{{tipo.options.carga}}</strong></span>
                                    </div>

                                    <div *ngIf="tipo.options.compartir_documentos" class="d-flex pd-lista">
                                        <img class="logo" src='../../assets/img/noe-free/icon-check-2.png' style="width: 18px; height: 18px; display: block; margin-right: 10px;">
                                        <span class="text-lista-2">Compartir documentos</span>
                                    </div>
                                    <div class="d-flex pd-lista">
                                        <img class="logo" src='../../assets/img/noe-free/icon-check-2.png' style="width: 18px; height: 18px; display: block; margin-right: 10px;">
                                        <span class="text-lista-2">Firma con terceros hasta <strong class="text-strong">{{tipo.options.firma_terceros}} veces</strong></span>
                                    </div>
                                    <div class="d-flex pd-lista">
                                        <img class="logo" src='../../assets/img/noe-free/icon-check-2.png' style="width: 18px; height: 18px; display: block; margin-right: 10px;">
                                        <span *ngIf="plan.id != 1" class="text-lista-2">Almacenamiento <strong class="text-strong">{{tipo.options.almacenamiento}}</strong></span>
                                        <span *ngIf="plan.id == 1" class="text-lista-2">Almacenamiento <strong class="text-strong"> por 30 días</strong></span>
                                    </div>
                                    <div *ngIf="tipo.options.soporte_tecnico != 'ninguna'" class="d-flex pd-lista">
                                        <img class="logo" src='../../assets/img/noe-free/icon-check-2.png' style="width: 18px; height: 18px; display: block; margin-right: 10px;">
                                        <span class="text-lista-2">Soporte técnico <strong class="text-strong">{{tipo.options.soporte_tecnico}}</strong></span>
                                    </div>
                                    <div class="d-flex pd-lista">
                                        <img class="logo" src='../../assets/img/noe-free/icon-check-2.png' style="width: 18px; height: 18px; display: block; margin-right: 10px;">
                                        <span class="text-lista-2">Podras firmar de manera <strong class="text-strong">{{tipo.options.nombres_firmas}}</strong></span>
                                    </div>
                                    <div *ngIf="tipo.options.capacitacion != 'ninguna'" class="d-flex pd-lista">
                                        <img class="logo" src='../../assets/img/noe-free/icon-check-2.png' style="width: 18px; height: 18px; display: block; margin-right: 10px;">
                                        <span class="text-lista-2">Capacitación <strong class="text-strong">{{tipo.options.capacitacion}}</strong></span>
                                    </div>
                                </div>
                            </ng-container>

                            <ng-container *ngIf="tipo.tipo == 'mensual'  &&  verMensual">
                                <span *ngIf="plan.id != 1 else planFree" class="text-precio-2">s/ {{tipo.costo}}.00 / mes</span>
                                <ng-template #planFree>
                                    <span class="text-precio-2">Cero Costo</span>
                                </ng-template>

                                <div class="hr-form-2"></div>

                                <div class="content-lista">
                                    <div class="d-flex pd-lista">
                                        <img class="logo" src='../../assets/img/noe-free/icon-check-2.png' style="width: 18px; height: 18px; display: block; margin-right: 10px;">
                                        <span *ngIf="plan.id != 1" class="text-lista-2"><strong class="text-strong">{{tipo.options.documentos}} Documentos</strong> mensuales disponibles</span>
                                        <span *ngIf="plan.id == 1" class="text-lista-2"><strong class="text-strong">{{tipo.options.documentos}} Documentos</strong> disponibles</span>
                                    </div>
                                    <div class="d-flex pd-lista">
                                        <img class="logo" src='../../assets/img/noe-free/icon-check-2.png' style="width: 18px; height: 18px; display: block; margin-right: 10px;">
                                        <span class="text-lista-2">Carga documentos de hasta <strong class="text-strong">{{tipo.options.carga}}</strong></span>
                                    </div>

                                    <div *ngIf="tipo.options.compartir_documentos" class="d-flex pd-lista">
                                        <img class="logo" src='../../assets/img/noe-free/icon-check-2.png' style="width: 18px; height: 18px; display: block; margin-right: 10px;">
                                        <span class="text-lista-2">Compartir documentos</span>
                                    </div>
                                    <div class="d-flex pd-lista">
                                        <img class="logo" src='../../assets/img/noe-free/icon-check-2.png' style="width: 18px; height: 18px; display: block; margin-right: 10px;">
                                        <span class="text-lista-2">Firma con terceros hasta <strong class="text-strong">{{tipo.options.firma_terceros}} veces</strong></span>
                                    </div>
                                    <div class="d-flex pd-lista">
                                        <img class="logo" src='../../assets/img/noe-free/icon-check-2.png' style="width: 18px; height: 18px; display: block; margin-right: 10px;">
                                        <span *ngIf="plan.id != 1" class="text-lista-2">Almacenamiento <strong class="text-strong">{{tipo.options.almacenamiento}}</strong></span>
                                        <span *ngIf="plan.id == 1" class="text-lista-2">Almacenamiento <strong class="text-strong"> por 30 días</strong></span>
                                    </div>
                                    <div *ngIf="tipo.options.soporte_tecnico != 'ninguna'" class="d-flex pd-lista">
                                        <img class="logo" src='../../assets/img/noe-free/icon-check-2.png' style="width: 18px; height: 18px; display: block; margin-right: 10px;">
                                        <span class="text-lista-2">Soporte técnico <strong class="text-strong">{{tipo.options.soporte_tecnico}}</strong></span>
                                    </div>
                                    <div class="d-flex pd-lista">
                                        <img class="logo" src='../../assets/img/noe-free/icon-check-2.png' style="width: 18px; height: 18px; display: block; margin-right: 10px;">
                                        <span class="text-lista-2">Podras firmar de manera <strong class="text-strong">{{tipo.options.nombres_firmas}}</strong></span>
                                    </div>
                                    <div *ngIf="tipo.options.capacitacion != 'ninguna'" class="d-flex pd-lista">
                                        <img class="logo" src='../../assets/img/noe-free/icon-check-2.png' style="width: 18px; height: 18px; display: block; margin-right: 10px;">
                                        <span class="text-lista-2">Capacitación <strong class="text-strong">{{tipo.options.capacitacion}}</strong></span>
                                    </div>
                                </div>
                            </ng-container>
                        </ng-container>

                        <button *ngIf="plan.checked && plan.id != 1 && (tipoPlanCategoria != plan.typeUser && !(plan.typeUser == 'anual' && verMensual))" class="btn-plan-2" (click)="capturarPlan(plan,verAnual);">Adquirir plan</button>
                        <button *ngIf="!plan.checked && (plan.id > this.miPlanActual.id)" class="btn-plan-2" (click)="capturarPlan(plan,verAnual);">Adquirir plan</button>

                        <button *ngIf="!plan.checked && (this.miPlanActual.id > plan.id)" class="btn-plan-2 btn-mi-plan">Adquirir plan</button>
                        <button *ngIf="plan.checked && (tipoPlanCategoria == plan.typeUser && plan.id != 1)" class="btn-plan-2 btn-mi-plan" >Adquirir plan</button>
                        <button *ngIf="plan.checked && plan.id == 1" class="btn-plan-2 btn-mi-plan" >Adquirir plan</button>
                        <button *ngIf="plan.checked && plan.id != 1 && (tipoPlanCategoria != plan.typeUser && (plan.typeUser == 'anual' && verMensual))" class="btn-plan-2 btn-mi-plan" >Adquirir plan</button>

                        <!--<button *ngIf="!plan.checked" class="btn-plan-2" (click)="capturarPlan(plan,verAnual);">Adquirir plan</button>
                        <button *ngIf="plan.checked" class="btn-plan-1 btn-mi-plan">Adquirir plan</button>-->
                    </div>

                    <div *ngIf="plan.id == 2" class="tabla1">
                        <span class="title-top">EL MÁS POPULAR</span>

                        <div class="tabla-sub">
                            <h3 class="text-title-1">{{plan.name}}</h3>
                            <ng-container *ngFor="let tipo of plan.attributes.tipo_plan; index as i;">
                                <ng-container *ngIf="tipo.tipo == 'anual'  &&  verAnual">
                                    <span class="text-precio-1">s/ {{tipo.costo}}.00 / al año</span>

                                    <div class="hr-form-1"></div>

                                    <div class="content-lista">
                                        <div class="d-flex pd-lista">
                                            <img class="logo" src='../../assets/img/noe-free/icon-check-1.png' style="width: 18px; height: 18px; display: block; margin-right: 10px;">
                                            <span class="text-lista-1"><strong>{{tipo.options.documentos}} Documentos</strong> mensuales disponibles</span>
                                        </div>
                                        <div class="d-flex pd-lista">
                                            <img class="logo" src='../../assets/img/noe-free/icon-check-1.png' style="width: 18px; height: 18px; display: block; margin-right: 10px;">
                                            <span class="text-lista-1">Carga documentos de hasta <strong>{{tipo.options.carga}}</strong></span>
                                        </div>

                                        <div *ngIf="tipo.options.compartir_documentos" class="d-flex pd-lista">
                                            <img class="logo" src='../../assets/img/noe-free/icon-check-1.png' style="width: 18px; height: 18px; display: block; margin-right: 10px;">
                                            <span class="text-lista-1">Compartir documentos</span>
                                        </div>
                                        <div class="d-flex pd-lista">
                                            <img class="logo" src='../../assets/img/noe-free/icon-check-1.png' style="width: 18px; height: 18px; display: block; margin-right: 10px;">
                                            <span class="text-lista-1">Firma con terceros hasta <strong>{{tipo.options.firma_terceros}} veces</strong></span>
                                        </div>
                                        <div class="d-flex pd-lista">
                                            <img class="logo" src='../../assets/img/noe-free/icon-check-1.png' style="width: 18px; height: 18px; display: block; margin-right: 10px;">
                                            <span class="text-lista-1">Almacenamiento <strong>{{tipo.options.almacenamiento}}</strong></span>
                                        </div>
                                        <div *ngIf="tipo.options.soporte_tecnico != 'ninguna'" class="d-flex pd-lista">
                                            <img class="logo" src='../../assets/img/noe-free/icon-check-1.png' style="width: 18px; height: 18px; display: block; margin-right: 10px;">
                                            <span class="text-lista-1">Soporte técnico <strong>{{tipo.options.soporte_tecnico}}</strong></span>
                                        </div>
                                        <div class="d-flex pd-lista">
                                            <img class="logo" src='../../assets/img/noe-free/icon-check-1.png' style="width: 18px; height: 18px; display: block; margin-right: 10px;">
                                            <span class="text-lista-1">Podras firmar de manera <strong>{{tipo.options.nombres_firmas}}</strong></span>
                                        </div>
                                        <div *ngIf="tipo.options.capacitacion != 'ninguna'" class="d-flex pd-lista">
                                            <img class="logo" src='../../assets/img/noe-free/icon-check-1.png' style="width: 18px; height: 18px; display: block; margin-right: 10px;">
                                            <span class="text-lista-1">Capacitación <strong>{{tipo.options.capacitacion}}</strong></span>
                                        </div>
                                    </div>
                                </ng-container>

                                <ng-container *ngIf="tipo.tipo == 'mensual'  &&  verMensual">
                                    <span class="text-precio-1">s/ {{tipo.costo}}.00 / mes</span>

                                    <div class="hr-form-1"></div>

                                    <div class="content-lista">
                                        <div class="d-flex pd-lista">
                                            <img class="logo" src='../../assets/img/noe-free/icon-check-1.png' style="width: 18px; height: 18px; display: block; margin-right: 10px;">
                                            <span class="text-lista-1"><strong>{{tipo.options.documentos}} Documentos</strong> mensuales disponibles</span>
                                        </div>
                                        <div class="d-flex pd-lista">
                                            <img class="logo" src='../../assets/img/noe-free/icon-check-1.png' style="width: 18px; height: 18px; display: block; margin-right: 10px;">
                                            <span class="text-lista-1">Carga documentos de hasta <strong>{{tipo.options.carga}}</strong></span>
                                        </div>

                                        <div *ngIf="tipo.options.compartir_documentos" class="d-flex pd-lista">
                                            <img class="logo" src='../../assets/img/noe-free/icon-check-1.png' style="width: 18px; height: 18px; display: block; margin-right: 10px;">
                                            <span class="text-lista-1">Compartir documentos</span>
                                        </div>
                                        <div class="d-flex pd-lista">
                                            <img class="logo" src='../../assets/img/noe-free/icon-check-1.png' style="width: 18px; height: 18px; display: block; margin-right: 10px;">
                                            <span class="text-lista-1">Firma con terceros hasta <strong>{{tipo.options.firma_terceros}} veces</strong></span>
                                        </div>
                                        <div class="d-flex pd-lista">
                                            <img class="logo" src='../../assets/img/noe-free/icon-check-1.png' style="width: 18px; height: 18px; display: block; margin-right: 10px;">
                                            <span class="text-lista-1">Almacenamiento <strong>{{tipo.options.almacenamiento}}</strong></span>
                                        </div>
                                        <div *ngIf="tipo.options.soporte_tecnico != 'ninguna'" class="d-flex pd-lista">
                                            <img class="logo" src='../../assets/img/noe-free/icon-check-1.png' style="width: 18px; height: 18px; display: block; margin-right: 10px;">
                                            <span class="text-lista-1">Soporte técnico <strong>{{tipo.options.soporte_tecnico}}</strong></span>
                                        </div>
                                        <div class="d-flex pd-lista">
                                            <img class="logo" src='../../assets/img/noe-free/icon-check-1.png' style="width: 18px; height: 18px; display: block; margin-right: 10px;">
                                            <span class="text-lista-1">Podras firmar de manera <strong>{{tipo.options.nombres_firmas}}</strong></span>
                                        </div>
                                        <div *ngIf="tipo.options.capacitacion != 'ninguna'" class="d-flex pd-lista">
                                            <img class="logo" src='../../assets/img/noe-free/icon-check-1.png' style="width: 18px; height: 18px; display: block; margin-right: 10px;">
                                            <span class="text-lista-1">Capacitación <strong>{{tipo.options.capacitacion}}</strong></span>
                                        </div>
                                    </div>
                                </ng-container>
                            </ng-container>

                            <!-- <button class="btn-plan-1" (click)="capturarPlan(plan,verAnual);">Adquirir plan</button> -->
                            <button *ngIf="!plan.checked && (plan.id > this.miPlanActual.id)" class="btn-plan-1" (click)="capturarPlan(plan,verAnual);">Adquirir plan</button>
                            <button *ngIf="plan.checked && (tipoPlanCategoria != plan.typeUser && !(plan.typeUser == 'anual' && verMensual))" class="btn-plan-1" (click)="capturarPlan(plan,verAnual);">Adquirir plan</button>

                            <button *ngIf="!plan.checked && (this.miPlanActual.id > plan.id)" class="btn-plan-1 btn-mi-plan">Adquirir plan</button>
                            <!--<button *ngIf="!plan.checked" class="btn-plan-1" (click)="capturarPlan(plan,verAnual);">Adquirir plan</button>-->
                            <button *ngIf="plan.checked && tipoPlanCategoria == plan.typeUser" class="btn-plan-1 btn-mi-plan" >Adquirir plan</button>
                            <button *ngIf="plan.checked && (tipoPlanCategoria != plan.typeUser && (plan.typeUser == 'anual' && verMensual))" class="btn-plan-1 btn-mi-plan" >Adquirir plan</button>

                        </div>
                    </div>

                </ng-container>
            </div>
        </div>

        <!-- Armando proceso de PAGO-->
        <div *ngIf="verProcesoPago && !verAnual && !verMensual && !verDetallesPago && !verModalGracias">
            <div class="double-row-plan">
                <div>
                    <i class="las la-angle-left icon-agregar" (click)="verProcesoPago = false; verAnual = true; tipoPlanCategoria = 'anual';"></i>
                    <span class="text-sub-proceso">Agrega más paquetes</span>

                    <div class="fondo-plan-1">
                        <div class="signature-container-free container-paquetes">
                            <div class="text-free-fondo d-flex justify-content-center" [class.text-fondo-padding]="verAddonsDoc">
                                <div class="triple-row-marketplace-btn expandColumn">
                                    <div>
                                        <div class="mk-img">
                                            <img src='../../assets/img/noe-free/icon-papel.png'  style="width: 55px; display: block; margin: 0 auto;">
                                        </div>
                                    </div>
                                    <div>
                                        <h6 class="text-free">Documentos</h6>
                                        <div class="cont-det-addons">
                                            <p class="text-free-desc-addons">¿Se te acabaron los documentos? Compra este paquete y disfruta de los beneficios.</p>
                                        </div>
                                    </div>
                                    <div class="content-arrow-addons">
                                        <i *ngIf="!verAddonsDoc" class="las la-angle-down icon-agregar-addons" (click)="verAddonsDoc=true;"></i>
                                        <i *ngIf="verAddonsDoc" class="las la-angle-up icon-agregar-addons" (click)="verAddonsDoc=false;"></i>
                                    </div>
                                </div>
                            </div>

                            <div *ngIf="verAddonsDoc">
                                <ng-container *ngFor="let paq of listaPaquetes; index as i;">
                                    <div *ngIf="paq.category=='documento'" class="text-free-fondo d-flex">
                                        <div class="five-row-marketplace-btn expandColumn">
                                            <div class="mk-img-addons">
                                                <img [src]="paq.src" style="width: 11px; display: block; margin: 0 auto;">
                                            </div>
                                            <div class="text-free-det-addons">
                                                {{paq.name}}
                                            </div>
                                            <div class="mk-precio-addons">
                                                S/ {{paq.costMarket}} / mes
                                            </div>
                                            <div class="container-button-mk">
                                                <button *ngIf="!paq.checked" class="mk-btn-flex-addons mk-btn-add-addons" (click)="agregarPaquete(paq)">Agregar</button>
                                                <button *ngIf="paq.checked" class="mk-btn-flex-addons mk-btn-add-addons" [class.disabled]="true" >Agregar</button>
                                            </div>
                                            <div class="container-button-mk">
                                                <button *ngIf="!paq.checked" class="mk-btn-flex-addons mk-btn-remove-addons" [class.disabled]="true"><i class="la-trash-alt las ng-star-inserted"></i></button>
                                                <button *ngIf="paq.checked" class="mk-btn-flex-addons mk-btn-remove-addons" (click)="quitarPaquete(paq)"><i class="la-trash-alt las ng-star-inserted"></i></button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="hr-form-addons"></div>
                                </ng-container>
                            </div>
                        </div>
                    </div>

                    <div class="fondo-plan-1">
                        <div class="signature-container-free container-paquetes">
                            <div class="text-free-fondo d-flex justify-content-center" [class.text-fondo-padding]="verAddonsFirma">
                                <div class="triple-row-marketplace-btn expandColumn">
                                    <div>
                                        <div class="mk-img">
                                            <img src='../../assets/img/noe-free/icon-escribiendo.png'  style="width: 55px; display: block; margin: 0 auto;">
                                        </div>
                                    </div>
                                    <div>
                                        <h6 class="text-free">Firma de terceros</h6>
                                        <div class="cont-det-addons">
                                            <p class="text-free-desc-addons">¿Quieres seguir compartiendo tus documentos para que sean firmados? Compra este paquete y disfruta de los beneficios.</p>
                                        </div>
                                    </div>
                                    <div class="content-arrow-addons">
                                        <i *ngIf="!verAddonsFirma" class="las la-angle-down icon-agregar-addons" (click)="verAddonsFirma=true;"></i>
                                        <i *ngIf="verAddonsFirma" class="las la-angle-up icon-agregar-addons" (click)="verAddonsFirma=false;"></i>
                                    </div>
                                </div>
                            </div>

                            <div *ngIf="verAddonsFirma">
                                <ng-container *ngFor="let paq of listaPaquetes; index as i;">
                                    <div *ngIf="paq.category=='firmante'" class="text-free-fondo d-flex">
                                        <div class="five-row-marketplace-btn expandColumn">
                                            <div class="mk-img-addons">
                                                <img [src]="paq.src" style="width: 11px; display: block; margin: 0 auto;">
                                            </div>
                                            <div class="text-free-det-addons">
                                                {{paq.name}}
                                            </div>
                                            <div class="mk-precio-addons">
                                                S/ {{paq.costMarket}} / mes
                                            </div>
                                            <div class="container-button-mk">
                                                <button *ngIf="!paq.checked" class="mk-btn-flex-addons mk-btn-add-addons" (click)="agregarPaquete(paq)">Agregar</button>
                                                <button *ngIf="paq.checked" class="mk-btn-flex-addons mk-btn-add-addons" [class.disabled]="true" >Agregar</button>
                                            </div>
                                            <div class="container-button-mk">
                                                <button *ngIf="!paq.checked" class="mk-btn-flex-addons mk-btn-remove-addons" [class.disabled]="true"><i class="la-trash-alt las ng-star-inserted"></i></button>
                                                <button *ngIf="paq.checked" class="mk-btn-flex-addons mk-btn-remove-addons" (click)="quitarPaquete(paq)"><i class="la-trash-alt las ng-star-inserted"></i></button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="hr-form-addons"></div>
                                </ng-container>
                            </div>
                        </div>
                    </div>

                    <div class="content-aviso">
                        <span class="text-footer">
                            En caso tu plan sea anual, se te cobrará el costo del paquete multiplicado por la cantidad de meses restantes hasta tu ciclo de facturación. Ejemplo: S/. 9 x 10
                        </span>
                    </div>

                </div>
                <div class="hr-form-vertical"></div>
                <div>
                    <span class="text-sub-proceso text-default">Tu selección:</span>
                    <div class="fondo-plan">
                        <div class="fondo-planes">
                            <h3 class="text-title-plan">Planes</h3>
                            <div class="hr-form-plan"></div>
                            <div class="d-flex modal-title content-desc">

                                <div class="d-flex">
                                    <img class="logo" src='../../assets/img/noe-free/icon-plan.png' style="height: 38px; padding-right: 10px;">
                                    <div>
                                        <h3 class="text-title-sub">{{planSeleccionado.name}}</h3>
                                        <div class="text-desc">
                                            <ul class="content-lista">
                                                <li><i class="las la-check"></i><span><strong>{{tipoPlanSeleccionado.options.documentos}} Documentos </strong>mensuales disponibles<strong></strong></span></li>
                                                <li><i class="las la-check"></i><span>Carga documentos de hasta <strong>{{tipoPlanSeleccionado.options.carga}}</strong></span></li>
                                                <li><i class="las la-check"></i><span>Firma con terceros hasta  <strong>{{tipoPlanSeleccionado.options.firma_terceros}} veces</strong></span></li>
                                                <li><i class="las la-check"></i><span>Podrás firmar de manera <strong>{{tipoPlanSeleccionado.options.nombres_firmas}}</strong></span></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                                <span class="precio-mes">S/ {{this.costoPlanSeleccionado}}.00  / {{tipoPlanSeleccionado.tipo}}</span>
                            </div>
                        </div>
                        <div class="fondo-detalle">
                            <h3 class="text-title-sub">Detalles de tu pago</h3>

                            <ng-coontainer *ngFor="let adic of paquetesAdicionales; index as i;">
                                <div class="d-flex modal-title container-text-paquete">
                                    <div class="text-desc">
                                        <span> + Añadiste <strong>{{adic.name}}</strong> adicionales a tu paquete inicial.
                                        </span>
                                    </div>
                                    <span class="precio-paquete">S/ {{adic.costoMarket}}</span>
                                </div>
                            </ng-coontainer>

                            <div class="hr-form-plan"></div>
                            <div class="d-flex modal-title">
                                <h3 class="text-title-sub-total">Pago total:</h3>
                                <span class="precio-mes">S/{{this.costoTotalCompra}} / {{tipoPlanSeleccionado.tipo}}</span>
                            </div>

                            <div class="d-flex modal-lista">
                                <div class="text-condiciones">
                                    *El monto total se debitará automáticamente según el plan elegido<br>
                                    *Puedes anular tu suscripción en cualquier momento<br>
                                    *Noe no almacena datos sensibles de tu tarjeta (fecha de vencimiento, CVV)
                                </div>
                                <button class="btn-continuar" [class.disabled]="!validarCheck" (click)="validarTipoPlan()">Continuar</button>
                            </div>
                        </div>

                    </div>
                    <div class="d-flex input-check-plan">
                        <label class="label-check">
                            <input type="checkbox" class="check" (change)="checkDeclarar($event.target.checked)">
                            <span class="d-inline-block"></span>
                        </label>
                        <div>
                            <span class="text-footer">Al suscribirme, acepto los </span><a (click)="abrirModalTyC()" class="text-link">términos y condiciones</a>
                            <span class="text-footer"> de NOE SOLUCIONES DIGITALES SAC. Puedes cancelar tu suscripción en cualquier momento yendo a la
                                opción "Cancelar suscripción" en la sección “Detalles de plan” en <strong>Facturación</strong>.</span>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <div *ngIf="verDetallesPago && !verProcesoPago && !verAnual && !verMensual && !verModalGracias">
            <span class="text-sub-proceso text-default text-left">Detalles del pago:</span>
            <form *ngIf="!verInformacionTransferencia" [formGroup]="pagoForm" class="formDetallePago">
                <div class="double-row-detalle-plan">
                    <div class="text-sub-proceso-first">
                        <span class="text-sub-proceso"></span>
                        <div class="fondo-plan">
                            <div class="fondo-planes content-planes">
                                <h3 class="text-title-plan text-title-center">{{planSeleccionado.name}}</h3>

                                <div class="hr-form-plan"></div>
                                <div class="d-flex modal-title">
                                    <h3 class="text-title-suscripcion text-underline">Suscripción {{tipoPlanSeleccionado.tipo}}</h3>
                                    <span class="precio-mes-detalle text-underline">S/ {{tipoPlanSeleccionado.costo}} / {{tipoPlanSeleccionado.tipo}}</span>
                                </div>

                                <div *ngIf="paquetesAdicionales.length > 0" class="hr-form-plan"></div>
                                <ng-coontainer *ngFor="let adic of paquetesAdicionales; index as i;">

                                    <div class="d-flex modal-title">
                                        <h3 class="text-title-paquetes"> + <strong>{{adic.name}}</strong> adicionales.</h3>
                                        <span class="precio-mes-paquetes">S/ {{adic.costoMarket}}</span>
                                    </div>
                                </ng-coontainer>

                                <div class="hr-form-plan"></div>
                                <div class="d-flex">
                                    <i class="las la-plus icon-cupon"></i>
                                    <h3 class="text-cupon-sub-detalle">Añadir cupón</h3>
                                </div>

                                <div class="hr-form-plan"></div>
                                <h3 class="text-title-sub">Métodos de Pago</h3>
                                <div class="content-bf-pago d-flex">
                                    <label class="container-tarjeta">
                                        <input type="radio" [(ngModel)]="checkedPago" value="Tarjeta" name="tipoTarjeta" formControlName="tipoTarjeta" (change)="checkTarjeta($event.target.checked)">
                                        <span class="checkmark-tarjeta"></span>
                                        <div class="d-flex modal-title-radio fondo-radio">
                                            <img src='../../assets/img/noe-free/logo-tarjeta.png' style="height: 26px; margin-top: 0px; margin-right: 5px;">
                                            <h3 class="text-title-sub-detalle">Tarjeta de crédito o débito</h3>
                                        </div>
                                    </label>
                                </div>

                                <h3 class="text-title-sub">Comprobantes</h3>
                                <div class="content-bf d-flex">
                                    <label class="container">
                                        <input type="radio" [(ngModel)]="checked" value="Boleta" name="tipoBoleta" formControlName="tipoBoleta" (change)="checkBoleta($event.target.checked)">
                                        <span class="checkmark"></span>
                                        <div class="d-flex modal-title-radio">
                                            <h3 class="text-title-sub-detalle right-check">Boleta</h3>
                                        </div>
                                    </label>
                                    <label class="container">
                                        <input type="radio" [(ngModel)]="checked" value="Factura" name="tipoFactura" formControlName="tipoFactura" (change)="checkFactura($event.target.checked)">
                                        <span class="checkmark"></span>
                                        <div class="d-flex modal-title-radio">
                                            <h3 class="text-title-sub-detalle right-check">Factura</h3>
                                        </div>
                                    </label>
                                </div>

                                <div class="hr-form-plan"></div>
                                <div class="d-flex modal-title">
                                    <h3 class="text-title-sub-total-detalle">Total:</h3>
                                    <span class="precio-total-detalle">S/ {{costoTotalCompra}} </span>
                                </div>

                                <div>
                                    <input type="hidden" name="tokenNiubizSession" id="tokenNiubizSession" value="{{tokenNiubizSession}}" />
                                    <input type="hidden" name="purchasenumber" id="purchasenumber" value="{{purchasenumber}}" />
                                </div>

                                <div>
                                    <button *ngIf="buttonPay" class="btn-pagar"
                                        [class.disabled]="(!tipoBoleta && !tipoFactura) || (!tipoTarjeta && !tipoTransferencia)" (click)="invocarAntifraude()">
                                        <span *ngIf="!tipoTransferencia">Suscribirme</span>
                                        <span *ngIf="tipoTransferencia">Continuar</span>
                                    </button>
                                    <button *ngIf="!buttonPay" class="btn-pagar disabled">Suscribirme</button>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </form>

            <div *ngIf="verInformacionTransferencia" class="text-sub-proceso-second">
                <div class="fondo-planes-info content-planes">
                    <h3 class="text-title-info">Compra en proceso de validación</h3>
                    <p class="text-info">Transferencia bancaria</p>
                    <img src='../../assets/img/noe-free/logo-transferencia.png' style="height: 26px; display: block; margin-left: 0px;">
                    <p class="text-info">Cuenta Corriente</p>
                    <p class="text-info">Número de cuenta: 200-3004795580</p>
                    <p class="text-info">CCI: 003-3004795580-333</p>
                    <p class="text-info">NOE Soluciones Digitales SAC RUC:</p>
                    <p class="text-info">2061008613</p>
                    <p class="text-info">Para validar su transacción, debe enviarnos un correo con su nombre, número de contacto y adjuntar comprobante de pago a:</p>
                    <p class="text-info">Correo electrónico: admin@noe.pe</p>
                    <p class="text-info">Una vez recibido su mensaje, en los próximos horas laborables se estará revisando su comprobante de pago.</p>
                    <p class="text-info">Nuestro horario de atención son de Lunes a Viernes de 8:30pm a 6:30pm</p>
                    <button class="btn-pagar btn-info" (click)="sharedPlan(); closeModalCambiadeplan();">Aceptar</button>
                </div>
            </div>

        </div>
    </div>

</app-modal>

<app-modal-lectura #modalTyC class="modal-lectura" titleModal="Términos y Condiciones" [scroller]="true">
    <app-terminos-y-condiciones-plan></app-terminos-y-condiciones-plan>
</app-modal-lectura>

<app-modal #modalBoletaFactura class="modalBoletaFactura" [hide-footer]="true">
    <span *ngIf="tipoBoleta" class="modal-title">Boleta</span>
    <span *ngIf="tipoFactura" class="modal-title">Factura</span>

    <form [formGroup]="boletaForm" *ngIf="boletaForm && tipoBoleta">
        <!--<div class="double-row-boleta">
            <app-input type="select" label="Tipo de Documento" [formControl]="boletaForm.controls['tipoDocumento']" [selectOptions]="tipoDocumentoBoleta"></app-input>
            <app-input type="text" label="N° de DNI" [formControl]="boletaForm.controls['dni']"></app-input>
        </div>-->
        <app-input type="text" label="N° de DNI" [formControl]="boletaForm.controls['dni']"></app-input>
        <app-input type="email" label="Correo Electrónico" [formControl]="boletaForm.controls['email']"></app-input>
    </form>

    <form [formGroup]="facturaForm" *ngIf="facturaForm && tipoFactura">
        <app-input type="text" label="N° de RUC" [formControl]="facturaForm.controls['ruc']"></app-input>
        <app-input type="email" label="Correo Electrónico" [formControl]="facturaForm.controls['email']"></app-input>
    </form>

    <div class="content-btn d-flex">
        <button class="btn btn-cancelar" type="submit" (click)="modalBoletaFactura.close(); deshabilitarCheck();">Cancelar</button>
        <button *ngIf="tipoBoleta" class="btn btn-aceptar" type="submit" (click)="guardarDatosBoleta($event)">Aceptar</button>
        <button *ngIf="tipoFactura" class="btn btn-aceptar" type="submit" (click)="guardarDatosFactura($event)">Aceptar</button>
    </div>
</app-modal>

<app-modal-lectura #modalLecturaTerminos titleModal="Términos y Condiciones" [scroller]="true">
    <app-terminos-y-condiciones></app-terminos-y-condiciones>
</app-modal-lectura>

<app-modal #passModal [hide-footer]="true" (onclose)="passForm.reset()" titleModal="Cambiar Contraseña">
    <h4>Fecha Actualizacion de Contraseña</h4>
    <div class="double-row">
        <p *ngIf="dataPassword"> {{dataPassword}}</p>
        <p *ngIf="dataPassword"><b>{{dataPasswordDate}} dias para vencer</b></p>
    </div>

    <form [formGroup]="passForm" (submit)="changePassword($event)" *ngIf="passForm">

        <app-input type="password" formControlName="oldPass" label="Contraseña Actual" [required]="true"></app-input>

        <app-input type="password" formControlName="password" label="Nueva Contraseña" [required]="true"></app-input>

        <app-input type="password" formControlName="confirm" label="Confirmar Contraseña" [required]="true"></app-input>

        <p class="error-message" *ngIf="passForm.errors?.mismatch">Las contraseñas deben coincidir</p>

        <app-password-validators [form]="passForm" [validators]="this.validators.validators">
        </app-password-validators>

        <div class="form-footer">
            <button *ngIf="!pLoading" class="btn" type="submit">Confirmar</button>

            <button *ngIf="pLoading" class="btn disabled loading" type="submit">
                Confirmando
            </button>
        </div>

    </form>

</app-modal>

<app-modal #editarMiCuentaModal [hide-footer]="true" titleModal="Editar Mi Cuenta">
    <form [formGroup]="usuarioForm" (submit)="handleSubmit($event)" *ngIf="usuarioForm">

        <app-input type="text" formControlName="name" label="Nombre" [required]="true"></app-input>

        <div class="double-row">
            <app-input type="text" label="Apellido Paterno" formControlName="paternalSurname" [required]="true"></app-input>

            <app-input type="text" label="Apellido Materno" formControlName="maternalSurname" [required]="true"></app-input>
        </div>

        <div class="double-row">
            <app-input type="select" label="Tipo de Documento" formControlName="identityType" [selectOptions]="tipoDocumentos" [required]="true"></app-input>

            <app-input type="text" label="Número de Documento" formControlName="identityNumber" [required]="true"></app-input>
        </div>

        <app-input type="email" label="Correo Electrónico" formControlName="email" [required]="true" [readonly]="true"></app-input>

        <div class="double-row">

            <app-input type="select" label="Código de país" formControlName="nationalType" [selectOptions]="countries" [selectOptionsName]="'optionName'" [selectOptionsKey]="'code'" [required]="true"></app-input>
            <app-input type="number" label="Teléfono" formControlName="phoneNumber" [required]="true"></app-input>
        </div>


        <div class="form-footer">
            <button *ngIf="!pLoading" class="btn" type="submit" [class.loading]="crearLoading">Confirmar</button>
            <button *ngIf="!pLoading" class="btn danger" type="button" (click)="cerrarModalEditarCuenta()">Cancelar</button>

            <button *ngIf="pLoading" class="btn disabled loading" type="submit">
                Confirmando
            </button>
        </div>

    </form>

    <ng-template #loading>
        <app-loader [big]="true"></app-loader>
    </ng-template>

</app-modal>


<app-modal #modalCambiarmeCuentaPago titleModal="CAMBIARME A CUENTA PREMIUM" [hide-footer]="true">
    <app-table #table [head]="headPremium" [body]="bodyPremium" [showPaginator]="false" [showIconSort]="false"></app-table>
    <div class="form-footer">
        <button class="btn success" (click)="aceptarCambiarmeCuentaPago()" [class.loading]="modalCambiarmeCuentaPagoLoading">Quiero que me contacten</button>
    </div>

</app-modal>

<app-modal-free #modalConfirmarLogout class="modalEliminarCuenta" titleModal="Confirmar" (onconfirm)="confirmarSalir()">
    <p class="text-eliminar">¿Estas seguro de cerrar sesión?</p>
</app-modal-free>
